import { useEffect, useState, memo } from "react";
import { toast } from "react-toastify";
import { createRoot } from "react-dom/client";
import { Icon } from "@utils/helper";
import { isHybrid } from "@network/http";
import { isPublic } from "@components/Authentication";

export const loadIntercomScript = async (
  pathname,
  lang,
  showIntercomBtn = false
) => {
  try {
    if (window.Intercom) return;
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = "https://widget.intercom.io/widget/b8uruxlc";
    script.onload = () => {
      window.Intercom("boot", {
        api_base: "https://api-iam.intercom.io",
        app_id: "b8uruxlc",
        ...(pathname === "/contact-us"
          ? { hide_default_launcher: true }
          : { hide_default_launcher: showIntercomBtn ? false : true }),
        ...(lang === "ar" ? { alignment: "left" } : {}),
        language_override: lang,
      });
      window.Intercom("show");
      document
        .querySelectorAll("#intercom-facade")
        .forEach((el) => el && el.remove());
    };
    document.body.appendChild(script);
  } catch (error) {
    console.error("Failed to load Intercom", error);
    toast.error("Failed to load Intercom");
  }
};

const IntercomBot = ({ lang, pathname, isAppQuery }) => {
  const [isIntercomLoaded, setIsIntercomLoaded] = useState(false);
  const showIntercom =
    pathname === "/" || isHybrid(pathname) || isPublic(pathname);

  useEffect(() => {
    const showIntercomBtn = isAppQuery ? false : showIntercom;

    const loadIntercom = async () => {
      if (!isIntercomLoaded) {
        setIsIntercomLoaded(true);
        await loadIntercomScript(pathname, lang, showIntercomBtn);
      }
    };

    document
      .querySelectorAll("#intercom-facade")
      .forEach((el) => el && el.remove());

    const facade = document.createElement("div");
    facade.id = "intercom-facade";
    facade.className = `fixed bottom-[20px] 450px:bottom-[30px] 
      ${showIntercomBtn ? "flex" : "hidden"}
      ${
        lang === "en"
          ? "right-[20px] 450px:right-[35px]"
          : "left-[20px] 450px:left-[35px]"
      } size-[48px] bg-[#0366FF] rounded-[50%] transform duration-300 hover:scale-110 z-[1000] justify-center items-center cursor-pointer shadow-md`;

    if (window.Intercom) {
      window.Intercom("update", {
        ...(pathname === "/contact-us"
          ? { hide_default_launcher: true }
          : { hide_default_launcher: showIntercomBtn ? false : true }),
        alignment: lang === "ar" ? "left" : "right",
        language_override: lang,
      });
      document
        .querySelectorAll("#intercom-facade")
        .forEach((el) => el && el.remove());
    } else {
      const root = createRoot(facade);
      root.render(<Icon id="Support" />);

      facade.onclick = loadIntercom;
      document.body.appendChild(facade);
    }
  }, [isIntercomLoaded, lang, pathname, isAppQuery]);

  return null;
};

export default memo(IntercomBot);
